export const columns = [
  {
    title: "往来单位编号",
    width: 200,
    dataIndex: "bizNo",
    key: "bizNo",
  },
  {
    title: "往来单位名称",
    width: 300,
    dataIndex: "companyName",
    key: "companyName",
  },
  {
    title: "往来单位类别",
    width: 300,
    slots: { customRender: "cooperationCompanyTypeNames" },
  },
  {
    title: "单位性质",
    width: 100,
    dataIndex: "companyNatureShowName",
    key: "companyNatureShowName",
  },
  {
    title: "所在地区",
    width: 200,
    slots: { customRender: "location" },
  },
];
